import { Nullable } from "../types/common";

export const formatMoney = (money: Nullable<number>): string =>
  `$ ${Number(money !== null ? money : 0).toFixed(2)}`;
